





















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonInspect from "@/components/common/button/ButtonInspect.vue";
import { InspectButtonValue } from "@/model/InspectButtonValue";
@Component({
  components: {
    ButtonInspect
  }
})
export default class ButtonInspectGroup extends Vue {
  @Prop({ default: 0 })
  value: number;
  @Prop({ default: 0 })
  status: number;
  @Prop({ default: -1 })
  public subCateIndex: number;
  @Prop({ default: -1 })
  public itemIndex: number;
  @Prop({ default: false })
  public isPriority: boolean;
  @Prop({ default: false })
  public hideTriangle: boolean;
  @Prop({ default: false })
  public isOsusume: boolean;

  currentValue: number = 0;
  $refs!: {
    circle: ButtonInspect;
    triangle: ButtonInspect;
    cross: ButtonInspect;
  };

  @Watch("value")
  onValueChange(value: any, oldVal: any) {
    let isActive = value > 0 ? true : false;
    this.setActive({ isActive, value: value, isAll: false });
  }

  mounted() {
    if (this.isOsusume) {
      this.setActive({ isActive: true, value: this.status, isAll: false });
    } else {
    if (this.value) {
      this.setActive({ isActive: true, value: this.value, isAll: false });
    }
    }
  }

  setActive(data: { isActive: boolean; value: number; isAll: boolean }) {
    let isChange = false;
    if (data.isActive) {
      if (this.isOsusume) {
        this.currentValue = data.value;
        if (data.value == 1) {
          this.$refs.circle.isActive = true;
          this.$refs.cross.isActive = false;
        } else {
          this.$refs.circle.isActive = false;
          this.$refs.cross.isActive = true;
        }
      } else {
      if ((data.isAll && !this.currentValue) || !data.isAll) {
        isChange = true;
        this.currentValue = data.value;
        this.$refs.circle.isActive = data.value == InspectButtonValue.CIRCLE;
        this.$refs.triangle.isActive =
          data.value == InspectButtonValue.TRIANGLE;
        this.$refs.cross.isActive = data.value == InspectButtonValue.CROSS;
      }
      }
    } else {
      if (this.currentValue == data.value) {
        console.log(this.currentValue);
        return false;
        // isChange = true;
        // this.currentValue = 0;
        // this.$refs.circle.isActive = false;
        // this.$refs.triangle.isActive = false;
        // this.$refs.cross.isActive = false;
      }
    }

    this.$emit("onchange", this.currentValue);
    return isChange;
  }

  onClick(data: any) {
    if (!this.isOsusume) {
      this.setActive(data);
    } else {
      this.$emit("onchange", data.osusumeIsShow);
    }
    this.$emit("onclick");
  }

  onconfirm(data: any) {
    this.$emit("onconfirm");
  }
}
